import * as React from 'react';
import { Column } from 'react-table';
import Table from '../../components/table/Table';
import { API_ROUTE, CLIENT_ROUTE, CLIENT_TITLE, STATEMENT } from './constants';
import type { Statement } from './types';
import { StatementStatus } from './types';
import Page from '../../components/layout/Page';
import dayjs from 'dayjs';
import { useListPage } from '../../hooks';
import RowActions from '../../components/table/RowActions';

interface IArtistRecord extends Pick<Statement, '_id' | 'recordNumber' | 'actionStatus' | 'amount' | 'createdAt' | 'transactionInfo' | 'actionNote' | 'description'> {
    actions: unknown;
}

const StatementList = () => {

    const { paginationState, handleInteraction, records, deleteRecord } = useListPage({
        clientRoute: CLIENT_ROUTE,
        apiRoute: API_ROUTE
    })

    const columns: Column<IArtistRecord>[] =  [
        {
            Header: 'Рекорд дугаар',
            accessor: 'recordNumber',
        },
        {
            Header: 'Төлөв',
            accessor: 'actionStatus',
            Cell(table) {
                let color: string | undefined = undefined;
                const actionStatus = table.row.original.actionStatus;
                if (actionStatus === StatementStatus.RESOLVED) {
                    color = '#13b513';
                }
                if (actionStatus === StatementStatus.FAILED) {
                    color = 'red';
                }
                return (
                    <span style={{ color }}>
                       {STATEMENT?.[actionStatus] ?? ''}
                    </span>
                )
            }
        },
        {
            Header: 'Дүн',
            accessor: 'amount',
        },
        {
            Header: 'Гүйлгээний утга',
            accessor: 'transactionInfo',
        },
        {
            Header: 'Тэмдэглэл',
            accessor: 'actionNote',
        },
        {
            Header: 'Тайлбар',
            accessor: 'description',
        },
        {
            Header: 'Огноо',
            accessor: 'createdAt',
            Cell: (table) => {
                const value = table.row.original.createdAt;
                const date = dayjs(value).format('YYYY-MM-DD HH:ss:mm')
                return (
                    <div>
                        {date}
                    </div>
                )
            }
        },
        {
            Header: '',
            accessor: 'actions',
            Cell: (table) => {
                return (
                    <RowActions id={table.row.original._id} clientRoute={CLIENT_ROUTE} />
                )
            }
        },
    ];

    return (
        <Page>
            <Page.Header title={CLIENT_TITLE}/>
            <Page.Body>
                <Table
                    searchable
                    columns={columns}
                    data={records}
                    totalPages={paginationState.totalPage}
                    onInteraction={handleInteraction}
                />
            </Page.Body>
        </Page>
    )
};

export default StatementList;